import React from 'react';
import { Card, Grid, CardContent, Divider } from '@mui/material';
import AccountInformation from './AccountInformation';
import AccountRoles from './AccountRoles';

const ProfileCard = ({
    isArabic,
    navigate,
    user,
    createdAtFormatted,
    displayRoles,
}) => {
    return (
        <Card
            sx={{
                p: 3,
                borderRadius: 4,
                boxShadow: 6,
                backdropFilter: 'blur(8px)',
            }}
        >
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={4}>
                    <AccountRoles
                        user={user}
                        isArabic={isArabic}
                        displayRoles={displayRoles}
                    />
                </Grid>
                <Divider sx={{ mb: 2 }} />
                <Grid item xs={12} md={8}>
                    <CardContent sx={{ p: 0 }}>
                        <AccountInformation
                            isArabic={isArabic}
                            user={user}
                            createdAtFormatted={createdAtFormatted}
                            onEdit={() => navigate(`/users/${user.id}/edit`)}
                        />
                    </CardContent>
                </Grid>
            </Grid>
        </Card>
    );
};

export default ProfileCard;
